import styled from "styled-components";

export const PlayAudioButton = styled.button`
  transition: transform 0.1s ease-out;
  &:hover {
    transform: scale(1.25);
  }
  &:active {
    transform: scale(1);
  }

  @media (max-width: 899px) {
    width: 36px;
    height: 36px;
  }
`;
